import { type GetterTree } from 'vuex';

import { type ITenantConfigurationState } from './types';

export const GET_UNIQUE = 'getUnique';

export const getters: GetterTree<ITenantConfigurationState, unknown> = {
    [GET_UNIQUE]: (_state) => {
        return Array.from(_state.dataObjectList, ([name, value]) => {
            return value;
        })?.[0];
    }
};
